import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface DualCameraState {
  isTokenSet: boolean
}

const initialState: DualCameraState = {
  isTokenSet: false,
}

const DualCameraSlice = createSlice({
  name: "dualCamera",
  initialState,
  reducers: {
    setIsTokenSet: (state, action: PayloadAction<boolean>) => {
      state.isTokenSet = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setIsTokenSet, resetState } = DualCameraSlice.actions
export default DualCameraSlice.reducer
